import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel, SectionTitle } from "@/components/Reveal";
import { lavori } from "@/data/lavori";

export default function Lavori() {
  return (
    <main data-testid="lavori-page" className="bg-slate-50">
      {/* HEADER */}
      <section className="pt-36 pb-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <SectionLabel>Lavori svolti</SectionLabel>
            <h1 className="font-serif font-medium mt-5 text-5xl md:text-7xl tracking-tight leading-[1.02] text-slate-900">
              Progetti<br />
              <em className="not-italic text-amber-800">e rilievi.</em>
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-3xl text-lg text-slate-600 leading-relaxed">
              Una selezione di interventi realizzati dallo studio: dalla progettazione
              edile ai rilievi topografici con drone, LIDAR e laser scanner. Clicca
              ogni categoria per vedere i lavori in dettaglio.
            </p>
          </Reveal>
        </div>
      </section>

      {/* GRID */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {lavori.map((l, idx) => {
            const totalImages = l.projects.reduce((acc, p) => acc + p.images.length, 0);
            return (
              <Reveal key={l.slug} delay={idx * 0.05}>
                <Link
                  to={`/lavori/${l.slug}`}
                  data-testid={`lavori-card-${l.slug}`}
                  className="group block bg-white border border-slate-200 hover:border-slate-900 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg h-full"
                >
                  <div className="aspect-[4/3] img-zoom bg-slate-100 overflow-hidden">
                    <img
                      src={l.cover}
                      alt={l.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-7 lg:p-9">
                    <div className="text-[10px] tracking-[0.22em] uppercase text-amber-800 font-semibold">
                      {l.category} · {l.projects.length} {l.projects.length === 1 ? "progetto" : "progetti"} · {totalImages} {totalImages === 1 ? "immagine" : "immagini"}
                    </div>
                    <h3 className="font-serif text-2xl lg:text-3xl mt-4 text-slate-900 leading-tight">
                      {l.title}
                    </h3>
                    <p className="mt-4 text-sm text-slate-600 leading-relaxed">{l.short}</p>
                    <div className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-slate-900">
                      Apri categoria
                      <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                    </div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl leading-tight">
              Hai un progetto simile?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link
              to="/contatti"
              data-testid="lavori-cta-contact"
              className="mt-8 inline-flex items-center gap-2 bg-amber-300 text-slate-900 px-8 py-4 rounded-full font-medium hover:bg-amber-200 transition-colors"
            >
              Richiedi un sopralluogo <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
